import { regionsController } from './regionscontroller';
import { proxyPhonesController } from './proxyphones/controller';
import { scheduleController } from './schedule/controller';
import { regionCampaignsController } from './settings/regioncampaigns/controller';
import { templatesController } from './templates/controller';

export const api = {
	schedule: scheduleController,
	templates: templatesController,
	regions: regionsController,
	regionCampaigns: regionCampaignsController,
	proxyPhones: proxyPhonesController
};
